'use client';

import { handleFormatDate } from 'helpers/format';

import { EventCollection } from 'types/sanity.types';

import { useTranslation } from 'hooks/use-translation';

import Image from 'components/nextjs-fixes/image';
import Link from 'components/nextjs-fixes/link';

import { styles } from '.';

type TProps = {
  item: EventCollection;
  //
  locale: string;
};

const EventListItem = (props: TProps) => {
  const { item, locale } = props;

  const { t } = useTranslation(locale);

  return (
    <Link href={`/${locale}/events/${item.slug}`} className={styles.container}>
      <figure className={styles.figure}>
        <Image
          className="object-cover"
          fill
          src={item.cover.asset?.url}
          alt="event-cover"
        />
      </figure>
      <div className={styles.content}>
        <div className={styles.head}>
          <p className="text-black text-xl pb-3">
            {handleFormatDate(item.date, t)} — {item.location}
          </p>
          <h3 className={styles.heading}>{item.title}</h3>
          <p className={styles.paragraph}>{item.summary}</p>
        </div>
        <div className={styles.body}>
          <p className={styles.button}>Lees meer</p>
        </div>
      </div>
    </Link>
  );
};

export default EventListItem;
